import { Selector } from '@ngrx/store';
import * as RouterStoreSelectors from './router.selector';

export const selectCurrentGroupId: Selector<object, string> = RouterStoreSelectors.selectRouterParam('g');

export const selectCurrentUserId: Selector<object, string> = RouterStoreSelectors.selectRouterParam('u');
